import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'nscf-legend',
  templateUrl: './legend.component.html',
  styleUrl: './legend.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex gap-4 mt-2 mb-8 slg:mt-6',
  },
})
export class LegendComponent {
  readonly legend = input<string>();
}
